var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"fulLoader",staticClass:"full-loader",staticStyle:{"display":"none"}},[_c('div',{ref:"backdrop",staticClass:"fade modal-backdrop",staticStyle:{"display":"none"}}),_vm._v(" "),(isNaN(_vm.data.percentage))?_c('circle-loader',{attrs:{"size":"sm"}}):_c('circle-loader',{attrs:{"size":"sm","show-perc":true,"percentage":_vm.data.percentage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c868850","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/dialogs/modalFullLoader.vue
// module id = 1333
// module chunks = 168 169